import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { MainContext } from '../../components/MainLayoutWrapper';

function BasisvaardighedenSelectModal({ show, setShow, vaardigheden = [], setMainVaardigheid }) {
    const navigate = useNavigate();
    const mainContext = useContext(MainContext);

    function onVaardigheidClick(slug) {
        setMainVaardigheid(slug);
        setShow(false);

        navigate(`/vakcurriculum/basisvaardigheden/${mainContext.activeFilters.klas}`);
    }

    return (
        <div className={'card-select-modal card-select-modal--small' + (show ? ' open' : '')}>
            <div className="card-select-modal__bg" onClick={() => setShow(false)}></div>

            <div className="card-select-modal__inner">
                <button type="button" className="card-select-modal__close-btn" onClick={() => setShow(false)}>Sluiten</button>

                <ul className="card-select-modal__topics">
                    {vaardigheden.map((vaardigheid, index) => {
                        return (
                            <li key={Math.random() + Math.random()} className="card-select-modal__topic">
                                <button type="button" onClick={() => onVaardigheidClick(vaardigheid.slug)}>
                                    {vaardigheid.name}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}

export default BasisvaardighedenSelectModal;